<template>
  <v-app style="overflow-x: hidden">
    <v-app-bar
      dense height="64" style="max-height:64px;"
      color="elements" dark />
    <v-row
      class="mx-0" justify="center" align-content="center"
      align="center">
      <v-col class="text-center" cols="12">
        <v-card flat>
          <img alt="GDi Smart Portal" src="./../../assets/logo.webp">
        </v-card>
      </v-col>
      <v-col class="text-center" cols="12">
        <v-card class="headerText--text" flat>
          <h1 style="font-weight:300" class="mt-5">
            Page not found.
          </h1>
          <h4 style="font-weight:300">
            The page you are trying to get to not existed.<br>
            Try going back to home page and repeating your action.
          </h4>
        </v-card>
      </v-col>
    </v-row>
    <v-row
      v-if="errorMessage" justify="center" align-content="center"
      align="center">
      <v-col class="text-center" cols="12">
        <span style="font-size: 22px">
          {{ errorMessage }}
        </span>
      </v-col>
    </v-row>
    <v-footer color="white" padless>
      <v-row justify="center" align-content="center" align="center">
        <v-col style="padding-bottom: 0px;" cols="4">
          <video
            autoplay loop muted
            playsinline>
            <source src="./../../assets/animacija.webm" type="video/webm">
          </video>
        </v-col>
      </v-row>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    errorMessage () {
      return this.$store.getters.getErrorMessage
    },
    shrinkToXS () {
      return this.$vuetify.breakpoint.xsOnly
    },
  },
}

</script>

<style>
video {
    max-width: 100%;
    height: auto;
    width: auto\9; /* ie8 */
}
</style>
